let template = `
    <div class="social_network">
        <div class="form-group col-md-2"><input class="form-control" name="socialNetworks[names][]" type="text" required></div>
        <div class="form-group col-md-9"><input class="form-control" name="socialNetworks[links][]" type="text" required></div>
        <div class="form-group col-md-1"><a href="#" class="btn btn-primary btn-danger btn-xs b-remove-social-network" style="margin-top: 5px;"><i class="fa fa-times"></i></a></div>
    </div>`;

let Domain = {
    init() {
        this.handlers();
    },
    
    addElem() {
        document.querySelector('.b-add-social-network').addEventListener('click', (evt) => {
            evt.target.closest('.form-group').insertAdjacentHTML('beforebegin', template);
            $('#social_network_header').show();
        });
    },
    
    removeElem() {
        document.querySelector('#social_links').addEventListener('click', (evt) => {
            if (evt.target.classList.contains('b-remove-social-network') || evt.target.closest('.b-remove-social-network')) {
                evt.target.closest('.social_network').remove();
                if (!$('.b-remove-social-network').length) {
                    $('#social_network_header').hide();
                }
            }
        });
    },
    
    handlers() {
        this.addElem();
        this.removeElem();
    },
};

export default Domain;
